import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useChat } from '../../context/ChatContext';
import FireIcon from '../../assets/icons/FireIcon';
import SearchIcon from '../../assets/icons/SearchIcon';
import EditIcon from '../../assets/icons/EditIcon';
import MessagesIcon from '../../assets/icons/MessagesIcon';
import ExitIcon from '../../assets/icons/ExitIcon';
import './BottomNav.css';

const BottomNav = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useAuth();
    const { unreadChatsCount } = useChat() || {};

    const isActive = (paths) => paths.some(p =>
        p === '/' ? location.pathname === '/' || location.pathname === '/popular' : location.pathname.startsWith(p)
    );

    const handleCreate = () => {
        if (user) navigate('/create-post');
        else navigate(`${location.pathname}?modal=login`);
    };

    const handleMessages = () => {
        if (user) navigate('/messages');
        else navigate(`${location.pathname}?modal=login`);
    };

    const handleProfile = () => {
        if (user) navigate('/profile');
        else navigate(`${location.pathname}?modal=login`);
    };

    return (
        <nav className="bottom-nav">
            <button
                className={`bottom-nav__item ${isActive(['/', '/popular', '/new']) ? 'bottom-nav__item--active' : ''}`}
                onClick={() => navigate('/popular')}
            >
                <FireIcon size={24} />
            </button>

            <button
                className={`bottom-nav__item ${isActive(['/search']) ? 'bottom-nav__item--active' : ''}`}
                onClick={() => navigate('/search')}
            >
                <SearchIcon size={24} />
            </button>

            <button
                className={`bottom-nav__item ${isActive(['/create-post']) ? 'bottom-nav__item--active' : ''}`}
                onClick={handleCreate}
            >
                <EditIcon size={24} />
            </button>

            <button
                className={`bottom-nav__item ${isActive(['/messages']) ? 'bottom-nav__item--active' : ''}`}
                onClick={handleMessages}
            >
                <div className="bottom-nav__icon-wrap">
                    <MessagesIcon size={24} />
                    {unreadChatsCount > 0 && (
                        <span className="bottom-nav__badge">{unreadChatsCount}</span>
                    )}
                </div>
            </button>

            <button
                className={`bottom-nav__item ${isActive(['/profile', '/user']) ? 'bottom-nav__item--active' : ''}`}
                onClick={handleProfile}
            >
                {user ? (
                    user.avatar ? (
                        <img src={user.avatar} alt="" className="bottom-nav__avatar" />
                    ) : (
                        <div className="bottom-nav__avatar bottom-nav__avatar--placeholder">
                            {(user.displayName ?? user.username).charAt(0).toUpperCase()}
                        </div>
                    )
                ) : (
                    <ExitIcon size={24} />
                )}
            </button>
        </nav>
    );
};

export default BottomNav;